
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 2a.333.333 0 00-.333.333v1H11c.92 0 1.666.746 1.666 1.667v6.333h1c.185 0 .334-.149.334-.333V2.333A.333.333 0 0013.666 2H5zm7.666 10.667h1c.921 0 1.667-.747 1.667-1.667V2.333c0-.92-.746-1.666-1.667-1.666H5c-.92 0-1.667.746-1.667 1.666v1h-1C1.413 3.333.667 4.08.667 5v8.667c0 .92.746 1.666 1.666 1.666H11c.92 0 1.666-.746 1.666-1.666v-1zm-10.333-8A.333.333 0 002 5v8.667c0 .184.15.333.333.333H11c.184 0 .333-.15.333-.333V5A.333.333 0 0011 4.667H2.333z","fill":"#4F9BF3"}})])
          )
        }
      }
    